import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ConfirmDialogOptions {
  message: string;
  header: string;
  icon?: string;
  acceptLabel?: string;
  rejectLabel?: string;
}

@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
  private confirmSubject = new Subject<ConfirmDialogOptions & { resolve: (value: boolean) => void }>();

  readonly confirm$ = this.confirmSubject.asObservable();

  confirm(options: ConfirmDialogOptions): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.confirmSubject.next({ ...options, resolve });
    });
  }
}
